// extracted by mini-css-extract-plugin
module.exports = {"topPadding":"HeaderSection_topPadding__SRPQp","heroImage":"HeaderSection_heroImage__AQS7J"};